import {all, call, put, takeLatest} from "redux-saga/effects";
import {getCtrStatus} from "../../api/systemStatus";
import {authFlowComplete} from "../features/authSlice";
import {
  getSystemStatus,
  getSystemStatusFailure,
  getSystemStatusSuccess
} from "../features/systemStatusSlice";

function* fetchSystemStatus() {
  try {
    const systemStatus = yield call(getCtrStatus);
    yield put(getSystemStatusSuccess(systemStatus));
  } catch (error) {
    console.error(error);
    yield put(getSystemStatusFailure(error.data));
  }
}

export default function* systemStatusSagas() {
  yield all([
    takeLatest([authFlowComplete, getSystemStatus], fetchSystemStatus)
  ]);
}
